import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

import defaultColor from './defaultColor';

export default function DecreaseIcon(props) {
  const color = props.color === 'secondary' ? '#b1b1b1' : props.color;
  return <SvgIcon {...props} viewBox="0 0 14 14" fill="none">
    <path id="Vector 334" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="M12.7313 12.4426c-0.0441 -0.0675 -4.59157 -6.66311 -5.37571 -7.21497 -1.02787 -0.7234 -1.50644 2.20844 -2.70205 2.11494C3.1652 7.22617 0.530522 1.5474 0.5 1.4989"
          strokeWidth="1"></path>
    <path id="Vector" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="M8.84814 11.7076c1.09785 0.6294 2.65556 0.9247 3.89426 0.7382 0.6009 -1.1502 0.8827 -2.78225 0.7047 -4.08008"
          strokeWidth="1"></path>
  </SvgIcon>
}
